import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import StoreSwitcher from 'components/Header/StoreSwitcher';

function StorePickerWrapper(props) {
    const { isInventoryAwareStorePickerEnabled, ...restProps } = props;

    if (isInventoryAwareStorePickerEnabled) {
        // Rendering the legacy Store Switcher, for now
        return <StoreSwitcher {...restProps} />;
    } else {
        return <StoreSwitcher {...restProps} />;
    }
}

export default wrapFunctionalComponent(StorePickerWrapper, 'StorePickerWrapper');
